/**
 * Felső erjesztésű   * BITTER_ALE - Bitter Ale   * BROWN_ALE - Brown Ale   * INDIA_PALE_ALE - India pale ale (IPA)   * PALE_ALE - Pale Ale   * BELGIAN_STRONG_ALE - Belga erős ale   * STRONG_ALE_OLD_ENGLISH_ALE - Strong Ale/Old English Ale   * MILD - Mild   * STOUT - Stout   * OATMEAL_STOUT - Oatmeal Stout   * SWEET_STOUT - Sweet Stout   * MILK_STOUT - Milk Stout   * IMPERIAL_STOUT - Imperial Stout   * PORTER - Porter   * BARLEY_WINE - Barley Wine   * SAISON_SEASONAL - Saison/Sezones   * SCOTCH_ALE_SCOTTISH_ALE_WEE_HEAVY - Scotch Ale/Scottish Ale/Wee Heavy   * TRAPPIST_BEER - Trappista sör
 */
export type TopFermented =
  | 'BITTER_ALE'
  | 'BROWN_ALE'
  | 'INDIA_PALE_ALE'
  | 'PALE_ALE'
  | 'BELGIAN_STRONG_ALE'
  | 'STRONG_ALE_OLD_ENGLISH_ALE'
  | 'MILD'
  | 'STOUT'
  | 'OATMEAL_STOUT'
  | 'SWEET_STOUT'
  | 'MILK_STOUT'
  | 'IMPERIAL_STOUT'
  | 'PORTER'
  | 'BARLEY_WINE'
  | 'SAISON_SEASONAL'
  | 'SCOTCH_ALE_SCOTTISH_ALE_WEE_HEAVY'
  | 'TRAPPIST_BEER';

export const TopFermented = {
  BitterAle: 'BITTER_ALE' as TopFermented,
  BrownAle: 'BROWN_ALE' as TopFermented,
  IndiaPaleAle: 'INDIA_PALE_ALE' as TopFermented,
  PaleAle: 'PALE_ALE' as TopFermented,
  BelgianStrongAle: 'BELGIAN_STRONG_ALE' as TopFermented,
  StrongAleOldEnglishAle: 'STRONG_ALE_OLD_ENGLISH_ALE' as TopFermented,
  Mild: 'MILD' as TopFermented,
  Stout: 'STOUT' as TopFermented,
  OatmealStout: 'OATMEAL_STOUT' as TopFermented,
  SweetStout: 'SWEET_STOUT' as TopFermented,
  MilkStout: 'MILK_STOUT' as TopFermented,
  ImperialStout: 'IMPERIAL_STOUT' as TopFermented,
  Porter: 'PORTER' as TopFermented,
  BarleyWine: 'BARLEY_WINE' as TopFermented,
  SaisonSeasonal: 'SAISON_SEASONAL' as TopFermented,
  ScotchAleScottishAleWeeHeavy:
    'SCOTCH_ALE_SCOTTISH_ALE_WEE_HEAVY' as TopFermented,
  TrappistBeer: 'TRAPPIST_BEER' as TopFermented,
};
